module.exports = __webpack_public_path__ + "img/logo.f530bfc4.png";